<app-selector label="Pdf" [isEmptySelectable]="isEmptySelectable" [data]="pdfCoreService.pdfList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="pdfCoreService.loading" [hint]="hint">
</app-selector>